import {
	GuarantorEntityType,
	PatientEntityType,
} from "@/lib/supabase/supabaseTypes";
import { PdfLetterhead } from "../pdf-template-components/pdf-letterhead.component";
import { PdfLayout } from "../pdf-template-components/pdf-layout.component";
import { PdfRecipientAddress } from "../pdf-template-components/pdf-recipient-address.component";
import "../fonts.css";
import { PdfTemplateType } from "../document-template.types";
import { PaymentSlipDataInput } from "../pdf-template-components/qr-payment-slip/qr-payment-helpers";
import { PdfInvoiceBody } from "../pdf-template-components/pdf-invoice-body.component";
import { CommonPDFTemplateProps } from "./types";
import { PdfFooter } from "../pdf-template-components/pdf-footer.component";

export interface BarzahlungsquittungTemplateProps
	extends CommonPDFTemplateProps {
	patient?: PatientEntityType;
	guarantor?: GuarantorEntityType;
	paymentSlipData: PaymentSlipDataInput;
}

export const BarzahlungsquittungTemplate: React.FC<
	BarzahlungsquittungTemplateProps
> = ({
	client,
	job,
	jobDocument,
	jobItems,
	organization,
	pdfTemplateConfiguration,
	patient,
	guarantor,
	paymentSlipData,
	jobTotals,
}) => {
	if (
		!organization ||
		!pdfTemplateConfiguration ||
		!job ||
		!jobDocument ||
		!jobItems ||
		!client ||
		!paymentSlipData
	) {
		return null;
	}
	return (
		<PdfLayout pdfTemplateConfiguration={pdfTemplateConfiguration}>
			<PdfLetterhead
				organization={organization}
				pdfTemplateConfiguration={pdfTemplateConfiguration}
				pdfType={PdfTemplateType.BARZAHLUNGSQUITTUNG}
			/>
			<PdfRecipientAddress
				recipient={job.guarantor_id && guarantor ? guarantor : client}
				pdfTemplateConfiguration={pdfTemplateConfiguration}
				template={PdfTemplateType.BARZAHLUNGSQUITTUNG}
			/>
			<PdfInvoiceBody
				title="Quittung"
				pdfTemplateConfiguration={pdfTemplateConfiguration}
				client={client}
				job={job}
				jobDocument={jobDocument}
				jobItems={jobItems}
				patient={patient}
				paymentSlipData={paymentSlipData}
				organization={organization}
				jobTotals={jobTotals}
			/>
			<PdfFooter
				templateType={PdfTemplateType.BARZAHLUNGSQUITTUNG}
				pdfTemplateConfiguration={pdfTemplateConfiguration}
			/>
		</PdfLayout>
	);
};
